module.exports = __webpack_public_path__ + "img/ico-4.5e5c8b86.svg";